export default __webpack_public_path__ + "static/media/pencil-edit-teal.94afcb08.svg";